
import getMaxValue from './get-max-value';

export default getMaxValue;
